export default __webpack_public_path__ + "static/media/low-battery.15eefd2d.svg";